import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'kubernetes' },
  path: 'iaas/kubernetes/create',
  name: 'kubernetes/create',
  component: () => import('@/views/dashboard/iaas/kubernetes/create/index.vue'),
} satisfies RouteRecordRaw;
